<template>
  <div class="index">
    <navi :activeIndex="1" :activeSub="true"></navi>
    <div class="container">
      <div class="t1">智能交通系统</div>
      <div class="c1">
        <img class="img1" src="@/assets/lj_01.jpg" alt="">
        <div class="t3">
          丰富的车辆种类，包含劳斯莱斯、五菱宏光、出租车、公
          交车、卡车、货车、大巴、Mini、普通家用车等各式各样
          的车型，并且车型有多种颜色，大大提升车辆的丰富度。
        </div>
      </div>
      <div class="c1">
        <img class="img1" src="@/assets/lj_02.jpg" alt="">
        <div class="t3">
          真实模拟道路交通情况，各式车辆遵循交通规则行驶， 变
          道、转弯、掉头都按规范打转向灯，停车、减速有刹车灯
          警示。前方有车辆时智能识别并且做出减速变道处理，公
          交车按自己的公交站路径行驶，并在公交站停留。
        </div>
      </div>
      <div class="c1">
        <img class="img1" src="@/assets/lj_03.jpg" alt="">
        <div class="t3">
          流畅逼真的雨天效果，并伴随着下雨的音效。雨滴落在车
          窗玻璃的效果真实，车辆判断下雨智能开启雨刮器帮助清
          理前车窗玻璃的雨滴。
        </div>
      </div>
      <div class="c1">
        <img class="img1" src="@/assets/lj_04.jpg" alt="">
        <div class="t3">
          虚拟红绿灯系统，包含正常的直行路口、三角路口、十字
          路口红绿灯。交通的车辆会自动遵循红绿灯规则行驶。除
          此之外，还有黄灯减速慢行路口，交通灯类型丰富。
        </div>
      </div>
      <div class="t1 t2">复杂路况模拟</div>
      <div class="c1">
        <div class="t3 t4">
          车道变窄时小心后方有车辆汇入。如图，由于右侧修路，
          导致在右侧车道的行驶车辆必须向左变道，然后这种时候
          更要小心注意左后方是否有车辆驶来。
        </div>
        <img class="img1" src="@/assets/lj_05.jpg" alt="">
      </div>
      <div class="c1">
        <div class="t3 t4">
          路口处车流量较多时应该注意减速慢行。特别经过有多个
          出口的路口时，由于车内存在视野盲区，需要减速慢行，
          确保行驶方向无车辆。
        </div>
        <img class="img1" src="@/assets/lj_06.jpg" alt="">
      </div>
      <div class="c1">
        <div class="t3 t4">
          超车时注意超越车辆一侧是否有来车变道。如图所示，白
          色车辆在超越卡车时，突然从卡车那一侧变道过了一辆五
          菱宏光，并且卡车那一侧属于视野盲区，是一种比较危险
          的行为，应注意防范。
        </div>
        <img class="img1" src="@/assets/lj_07.jpg" alt="">
      </div>
      <div class="c1">
        <div class="t3 t4">
          隧道堵车时，应该打开双闪或示廓灯，给后面车辆警示效
          果，减速慢行通过隧道。
        </div>
        <img class="img1" src="@/assets/lj_08.jpg" alt="">
      </div>
      <div class="c1">
        <div class="t3 t4">
          经过十字路口时，路口右侧有车辆左转，应该多观察四周，
          注意减速避让，慢行通过。
        </div>
        <img class="img1" src="@/assets/lj_09.jpg" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import Navi from "./Navi.vue";
export default {
  name: "ProductSoft",
  components: {
    Navi
  },
  data() {
    return {};
  },
  created() {},
  methods: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.index {
  /* background-color: rgb(43, 43, 51); */
}

.container {
  /* box-shadow: 0px 0px 6px #999; */
  width: 1200px;
  /* height: 500px; */
  margin: 120px auto;
}
.t1 {
  font-size: 44px;
  color: #333;
  text-align: left;
}
.t2 {
  margin-top: 150px;
}
.c1 {
  margin-top: 60px;
  display: flex;
}
.t3 {
  margin-left: 40px;
  font-size: 24px;
  text-align: left;
  line-height: 38px;
  color: #666;
  display: inline-block;
  flex: 1;
}
.t4 {
  margin-left: 0px;
  margin-right: 40px;
}
.img1 {
}
@media only screen and (max-width: 800px) {
  .container {
    width: auto;
    margin: 60px 30px;
  }
  .t1 {
    font-size: 32px;
  }
  .t2 {
    margin-top: 80px;
  }
  .t3 {
    margin-left: 0px;
    margin-top: 10px;
    display: block;
  }
  .t4 {
    margin-right: 0px;
  }
  .c1 {
    margin-top: 40px;
    display: block;
  }
  .img1 {
    width: 100%;
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ProductSoft.vue